import { render, staticRenderFns } from "./VListTraining.vue?vue&type=template&id=7ec7afde&scoped=true&"
import script from "./VListTraining.vue?vue&type=script&lang=js&"
export * from "./VListTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec7afde",
  null
  
)

export default component.exports